import * as React from 'react';

import { useQuery } from '@apollo/client';
import { LinearProgress } from '@mui/material';
import { useSelector } from 'react-redux';

import UserRolesResult from './UserRolesResult';
import UserByEmailQuery from '../../graphql/queries/UserByEmail';
import selectViewerUserId from '../../selectors/viewerUserId';

interface Props {
  email: string;
}

const UserResult: React.FC<Props> = ({ email }: Props) => {
  const currentUserId = useSelector((state) => selectViewerUserId(state));

  const {
    loading: userLoading,
    error: userError,
    data: userData,
  } = useQuery(UserByEmailQuery, {
    variables: {
      email: email,
    },
  });

  if (userLoading) {
    return <LinearProgress />;
  }

  if (userData.user === null || userError) {
    return <h4>User not found!</h4>;
  }

  if (userData.user.id === currentUserId) {
    return <h4>Cannot edit current user!</h4>;
  }

  return <UserRolesResult userId={userData.user.id} />;
};

export default UserResult;
